
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, Ethnicity } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class EthnicityEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    ethnicity: Ethnicity;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getEthnicity()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getEthnicity(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.ethnicity = data;
                this.onDataChanged.next(this.ethnicity);
                resolve(this.ethnicity);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('ethnicity/' + this.routeParams.id).subscribe((res: Ethnicity ) => {
                    this.ethnicity = res;
                    this.onDataChanged.next(this.ethnicity);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(ethnicity): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('ethnicity/', ethnicity).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(ethnicity): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('ethnicity/', ethnicity).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(ethnicity): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('ethnicity/' + ethnicity.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): Ethnicity {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
